[
  {
  "id": 1,
  "description": "jednorazovo",
  "textToTranslate": "payment-frequency.once"
  },
  {
    "id": 2,
    "description": "ročne",
    "textToTranslate": "payment-frequency.annually"
  },
  {
    "id": 3,
    "description": "polročne",
    "textToTranslate": "payment-frequency.semi-annually"
  },
  {
    "id": 4,
    "description": "štvrťročne",
    "textToTranslate": "payment-frequency.quarterly"
  },
  {
    "id": 5,
    "description": "mesačne",
    "textToTranslate": "payment-frequency.monthly"
  },
  {
    "id": 6,
    "description": "špeciálne (30-40-30)",
    "textToTranslate": "payment-frequency.special"
  },
  {
    "id": 7,
    "description": "Splátkový kalendár",
    "textToTranslate": "payment-frequency.payment-calendar"
  }
]
